import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  ThemeProvider,
  Button,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { customDialogRegroupParcelsTheme } from 'assets/styles/themes/Dialog/generic_dialog_regroup_parcel';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import Clear from '@mui/icons-material/Clear';

type ProcedureOvertakeModalParams = {
  modalOvertakeProcedure: boolean;
  setModalProcedure: (value: boolean) => void;
  setModalOvertakeProcedure: (value: boolean) => void;
  setWillOvertakeProcedure: (value: boolean) => void;
};
const ProcedureOvertakeModal = ({
  modalOvertakeProcedure,
  setModalProcedure,
  setModalOvertakeProcedure,
  setWillOvertakeProcedure,
}: ProcedureOvertakeModalParams) => {
  return (
    <ThemeProvider theme={customDialogRegroupParcelsTheme}>
      <Dialog
        maxWidth="lg"
        fullWidth
        open={modalOvertakeProcedure}
        onClose={() => setModalOvertakeProcedure(false)}
      >
        <Box>
          <DialogTitle>Prendre le contrôle de la procédure</DialogTitle>
          <ClearIcon onClick={() => setModalOvertakeProcedure(false)} />
        </Box>
        <DialogContent>
          <DialogContentText className="whiteSpacePreWrap">
            La procédure est en cours et non finalisée mais cela fait plus d'une heure et vous
            pouvez prendre le contrôle de la procédure. Attention cependant tous les changements
            effectués par les autres utilisateurs seront annulés.
          </DialogContentText>
          <br />
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={customButtonTheme}>
            <Button
              id="inputConfirmOvertake"
              onClick={() => {
                setModalOvertakeProcedure(false);
                setModalProcedure(true);
                setWillOvertakeProcedure(true);
              }}
            >
              Prendre le contrôle
            </Button>
          </ThemeProvider>
          <Button
            id="inputConfirmOvertake"
            onClick={() => {
              setModalOvertakeProcedure(false);
            }}
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ProcedureOvertakeModal;
